module.exports = __webpack_public_path__ + "img/logo-fake2.e08b4167.svg";